module.exports = __webpack_public_path__ + "img/SpectroPicAscii.c9e6f3af.png";